import { IntegrationState, SplashState } from '../state';
import { AppState } from '../state/app.state';

export const selectSplash = (state: AppState): SplashState => state.splash;

export const selectIntegrationType = (state: AppState): IntegrationState => state.integration;
